export { QuantityItem } from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/QuantityItem';
